<template>
	<ion-page>
		<spot-header :title="recActivity + pageTitle" :canGoHome="true" :showLogo="false" @pressedGoHome="tryExit"></spot-header>
		<ion-content :fullscreen="true">
			<ion-item v-if="!isActive || updatingLibraries">
				<ion-spinner name="lines" color="primary"></ion-spinner>
				<ion-label color="primary">{{ spinnerText}}</ion-label>
			</ion-item>
			<div id="actionArea" v-if="isActive">
				<div id="fieldsContainer" class="content-rows"> <!--v-if="isActive"-->
					<div v-if="currField.id == field.employee">
						<spot-select-custom
							:ref="currField.name"
							:label="currField.text"
							:allignLabel="currField.allignLabel"
							:required="currField.required"
							:placeholder="getPlaceHolder()"
							:enabled="!isClosed"
							:value="currField.value"
							:options="tablesData.employees"
							:optionField="currField.refField"
							:canAddItem="currField.canAddItem"
							:canRefreshList="currField.canRefresh"
							:canUnlock="currField.canUnlock"
							:custom-label="customEmployee"
							selectedLabel="Selezionato"
							deselectLabel="rimuovi"
							selectLabel="seleziona"
							@selected="detectSelection"
							@unselected="detectUnselection"
							@addItem="addEmployee">
						</spot-select-custom>
					</div>
					<div v-if="currField.id == field.addressee">
						<spot-select
							:ref="currField.name"
							:label="currField.text"
							:allignLabel="currField.allignLabel"
							:required="currField.required"
							:placeholder="getPlaceHolder()"
							:enabled="!isClosed"
							:value="currField.value"
							:options="tablesData.addressees"
							:optionField="currField.refField"
							:canAddItem="currField.canAddItem"
							:canRefreshList="currField.canRefresh"
							:canUnlock="currField.canUnlock"
							selectedLabel="Selezionato"
							deselectLabel="rimuovi"
							selectLabel="seleziona"
							@selected="detectSelection"
							@unselected="detectUnselection"
							@addItem="addAddressee">
						</spot-select>
					</div>
					<div v-if="currField.id == field.carrier">
						<spot-select
							:ref="currField.name"
							:label="currField.text"
							:allignLabel="currField.allignLabel"
							:required="currField.required"
							:placeholder="getPlaceHolder()"
							:enabled="!isClosed"
							:value="currField.value"
							:options="tablesData.carriers"
							:optionField="currField.refField"
							:canAddItem="currField.canAddItem"
							:canRefreshList="currField.canRefresh"
							:canUnlock="currField.canUnlock"
							selectedLabel="Selezionato"
							deselectLabel="rimuovi"
							selectLabel="seleziona"
							@selected="detectSelection"
							@unselected="detectUnselection"
							@addItem="addCarrier">
						</spot-select>
					</div>
					<div v-if="currField.id == field.item">
						<spot-select
							:ref="currField.name"
							:label="currField.text"
							:allignLabel="currField.allignLabel"
							:required="currField.required"
							:placeholder="getPlaceHolder()"
							:enabled="!isClosed"
							:value="currField.value"
							:options="tablesData.items"
							:optionField="currField.refField"
							:canAddItem="currField.canAddItem"
							:canRefreshList="currField.canRefresh"
							:canUnlock="currField.canUnlock"
							selectedLabel="Selezionato"
							deselectLabel="rimuovi"
							selectLabel="seleziona"
							@selected="detectSelection"
							@unselected="detectUnselection"
							@addItem="addItem">
						</spot-select>
					</div>
					<div v-if="currField.id == field.pictures">
						<div class="items-label">
							<ion-label>{{ currField.text }}</ion-label>
							<span v-if="currField.required">*</span>
						</div>
						<div class="items-data">
							<take-photo :enabled="!isClosed" :srcImage="currField.value" @saved="assignImage" @removed="clearImage" @cameraError="cameraNotFound"></take-photo>
							<!-- Example to browse photo on mobile and PC directories <input type="file" capture="camera" accept="image/*" id="cameraInput" name="cameraInput"> -->
							<ion-button fill="clear" :disabled="!currField.canAddItem" v-if="isVisibleButton(currField.canAddItem && !isClosed)" @click="addItem()">
								<ion-icon slot="icon-only" :icon="addCircleOutline" size="large"></ion-icon>
							</ion-button>
						</div>
					</div>
					<div v-if="currField.id == field.waiting_for_proforma">
						<div class="items-label">
							<ion-label>{{ currField.text }}</ion-label>
							<span v-if="currField.required">*</span>
						</div>
						<div class="items-data">
							<ion-checkbox slot="start" v-model="currField.value" :placeholder="getPlaceHolder()" :disabled="isClosed"></ion-checkbox>
							<ion-button fill="clear" :disabled="!currField.canAddItem" v-if="isVisibleButton(currField.canAddItem) && !isClosed" @click="addItem()">
								<ion-icon slot="icon-only" :icon="addCircleOutline" size="large"></ion-icon>
							</ion-button>
						</div>
					</div>
					<div v-if="currField.id == field.urgent">
						<div class="items-label">
							<ion-label>{{ currField.text }}</ion-label>
							<span v-if="currField.required">*</span>
						</div>
						<div class="items-data">
							<ion-checkbox slot="start" v-model="currField.value" :placeholder="getPlaceHolder()" :disabled="isClosed"></ion-checkbox>
							<ion-button fill="clear" :disabled="!currField.canAddItem" v-if="isVisibleButton(currField.canAddItem) && !isClosed" @click="addItem()">
								<ion-icon slot="icon-only" :icon="addCircleOutline" size="large"></ion-icon>
							</ion-button>
						</div>
					</div>
					<div v-if="currField.id == field.note">
						<spot-input
							:ref="currField.name"
							:label="currField.text"
							:allignLabel="currField.allignLabel"
							:required="currField.required"
							:placeholder="getPlaceHolder()"
							:enabled="!isClosed"
							:value="currField.value"
							:type="currField.inputType"
							:clearInput="true"
							:canUnlock="currField.canUnlock"
							@textChanged="changedInput"
							@committed="committedInput">
						</spot-input>
					</div>
					<div v-if="currField.id == field.review">
						<div class="items-label">
							<table style="width:100%">
								<tr>
									<th>{{ currField.text }}</th>
									<th>{{ new Intl.DateTimeFormat("it-IT").format(new Date()) }}</th>
								</tr>
							</table>
							<!-- <ion-label>{{ currField.text }} {{ new Intl.DateTimeFormat("it-IT").format(new Date()) }}</ion-label> -->
							<span v-if="currField.required">*</span>
						</div>
						<div class="review-items">
							<ion-item lines="full" @click="goToField(fields.list[field.employee].id)">
								<ion-label>{{ fields.list[field.employee].text }}:</ion-label>
								<!--<ion-input v-if="(fields.list[field.employee].value)" type="text" readonly :value="fields.list[field.employee].value.name + ' ' + fields.list[field.employee].value.surname + (!fields.list[field.employee].value.department ? '' : ' (' + fields.list[field.employee].value.department.name + ')')"></ion-input>-->
								<ion-input v-if="(fields.list[field.employee].value)" type="text" readonly :value="getEmployeeDepartment(fields.list[field.employee].value)"></ion-input>
							</ion-item>
							<ion-item lines="full" @click="goToField(fields.list[field.addressee].id)">
								<ion-label>{{ fields.list[field.addressee].text }}:</ion-label>
								<ion-input v-if="(fields.list[field.addressee].value)" type="text" readonly v-model="fields.list[field.addressee].value.name"></ion-input>
							</ion-item>
							<ion-item lines="full" @click="goToField(fields.list[field.carrier].id)">
								<ion-label>{{ fields.list[field.carrier].text }}:</ion-label>
								<ion-input v-if="(fields.list[field.carrier].value)" type="text" readonly v-model="fields.list[field.carrier].value.name"></ion-input>
							</ion-item>
							<ion-item lines="full" @click="goToField(fields.list[field.item].id)">
								<ion-label>{{ fields.list[field.item].text }}:</ion-label>
								<ion-input v-if="(fields.list[field.item].value)" type="text" readonly v-model="fields.list[field.item].value.code"></ion-input>
							</ion-item>
							<ion-item slot="start" lines="full" :disabled="currField.value" @click="goToField(fields.list[field.pictures].id)">
								<ion-label position="fixed">{{ fields.list[field.pictures].text }}:</ion-label>
								<ion-thumbnail v-if="(fields.list[field.pictures].value)"><img :src="getImageUrl" /></ion-thumbnail>
							</ion-item>
							<ion-item lines="full" @click="goToField(fields.list[field.waiting_for_proforma].id)">
								<ion-label>{{ fields.list[field.waiting_for_proforma].text }}:</ion-label>
								<!--<ion-checkbox slot="end" v-model="fields.list[field.waiting_for_proforma].value" :disabled="true"></ion-checkbox>-->
								<ion-input type="text" readonly :value="(fields.list[field.waiting_for_proforma].value) ? 'Si' : 'No'"></ion-input>
							</ion-item>
							<ion-item lines="full" @click="goToField(fields.list[field.urgent].id)"> <!-- currField.name == 'urgent' -->
								<ion-label>{{ fields.list[field.urgent].text }}:</ion-label>
								<!--<ion-checkbox slot="end" v-model="fields.list[field.urgent].value" :disabled="true"></ion-checkbox>-->
								<ion-input type="text" readonly :value="(fields.list[field.urgent].value) ? 'Si' : 'No'"></ion-input>
							</ion-item>
							<ion-item lines="full" @click="goToField(fields.list[field.note].id)"> <!-- currField.name == 'note' -->
								<ion-label>{{ fields.list[field.note].text }}:</ion-label>
								<ion-input v-if="(fields.list[field.note].value)" type="text" readonly v-model="fields.list[field.note].value"></ion-input>
							</ion-item>
						</div>
					</div>
				</div>
				<div id="actionsContainer">
					<spot-button
						v-if="isVisibleButton(currField.canGoBack)"
						fill="clear"
						size="large"
						color="primary"
						icon="chevronBackCircleOutline"
						:enabled="currField.canGoBack && !fields.list[this.fields.list.length-1].value"
						:expand="null"
						:text=null
						@clicked="goBack()">
					</spot-button>
					<spot-button
						v-if="isVisibleButton(currField.canSkip)"
						fill="clear"
						size="large"
						color="primary"
						icon="playSkipForwardCircleOutline"
						:enabled="!isEmptyRequiredFields()"
						:expand="null"
						:text=null
						@clicked="goToReview()">
					</spot-button>
					<ion-button
						class="multi-icons-button"
						v-if="isVisibleButton(currField.canSave && !isClosed)"
						:fill= "(showActionButtonsText) ? 'outline' : 'clear'"
						size="small"
						color="primary"
						:disabled="isEmptyRequiredFields()"
						@click="createAndPrint()">
						{{ (showActionButtonsText && !currField.value) ? (canPrint && !this.$route.params.id ? labelSave + labelAnd + labelPrint : labelSave) : (showActionButtonsText && canPrint && !this.$route.params.id ? labelReprint : null) }}
						<ion-icon v-if="!currField.value" slot="icon-only" :icon="save" size="large"></ion-icon>
						<ion-icon v-if="canPrint && !this.$route.params.id" slot="icon-only" :icon="print" size="large"></ion-icon>
					</ion-button>
					<spot-button
						v-if="isVisibleButton(currField.canSave && !isClosed && multiple && currField.value)"
						:fill= "(showActionButtonsText) ? 'outline' : 'clear'"
						size="small"
						color="primary"
						icon="personCircleOutline"
						:enabled="!isEmptyRequiredFields()"
						:expand="null"
						:text="(showActionButtonsText) ? labelEmployee : null"
						@clicked="executeAction('NewEmployee')">
					</spot-button>
					<spot-button
					v-if="isVisibleButton(currField.canSave && !isClosed && multiple && currField.value)"
						:fill= "(showActionButtonsText) ? 'outline' : 'clear'"
						size="small"
						color="primary"
						icon="trailSign"
						:enabled="!isEmptyRequiredFields()"
						:expand="null"
						:text="(showActionButtonsText) ? labelAddressee : null"
						@clicked="executeAction('NewAddressee')">
					</spot-button>
					<spot-button
						v-if="isVisibleButton(currField.canSave && !isClosed && currField.value)"
						:fill= "(showActionButtonsText) ? 'outline' : 'clear'"
						size="small"
						color="primary"
						icon="exit"
						:enabled="!isEmptyRequiredFields()"
						:expand="null"
						:text="(showActionButtonsText) ? labelExit : null"
						@clicked="executeAction('Exit')">
					</spot-button>
					<spot-button
						v-if="isVisibleButton(currField.canGoAhead)"
						fill="clear"
						size="large"
						color="primary"
						icon="chevronForwardCircleOutline"
						:enabled="!isDisableButton(currField.canGoAhead)"
						:expand="null"
						:text=null
						@clicked="goAhead()">
					</spot-button>
				</div>
			</div>
			<div id="debugArea" style="color:red;" v-if="settings.global.debug">
				<div>Test Area</div>
				Current Field: {{ currField }}<br>
				<div v-for="element in fields.list" :key="element.id">
					{{ element.name }} = {{ element.value }}
				</div>
			</div>
		</ion-content>
	</ion-page>
</template>

<style src="vue-multiselect/dist/vue-multiselect.css"></style> <!--<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>-->
<style scoped>
	ion-label {
		font-weight:bold;
	}
	.content-rows {
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
		/*justify-content: space-around;*/
		/*align-content: flex-start;*/
		/*padding: 1em;*/
		/*height: 10%;*/
		/*overflow: auto;*/
	}
	.items-label {
		margin-top: .5em;
		margin-left: 1em;
	}
	.items-data {
		display: flex; /*inline-block;*/
		flex-direction: row;
		vertical-align: baseline;
		justify-content: space-between;
		text-align: left;
		margin-left: .5em;
		margin-right: .5em;
	}
	ion-checkbox {
		margin-top: .5em;
		margin-left: .5em;
	}
	.multi-icons-button {
		margin-top: .5em;
		margin-left: .25em;
		margin-right: .25em;
		font-size: 20px;
		--padding-start: 2vw;
		--padding-end: 2vw;
	}
	.multi-icons-button ion-icon {
		font-size: 20px;
		--padding-start: 2vw;
		--padding-end: 2vw;
	}
	.review-items ion-item {
		--min-height: 0px;
	}
	.review-items ion-input {
		--padding-top: .5vh;
		--padding-bottom: .5vh;
	}
	.review-items :is(ion-label, ion-thumbnail) {
		margin-top: .5vh;
		margin-bottom: .5vh;
	}
	table, th, td {
		border: 0px solid black;
	}
</style>

<script> //TODO: Da capire dove mettere il canTakePhoto (globale o a livello di campo) e i can<Other> (se servono)
	import { IonButton, IonCheckbox, IonContent, IonIcon, IonInput, IonItem, IonLabel, IonPage, IonSpinner, IonThumbnail } from "@ionic/vue";
	import { addCircleOutline, chevronBackCircleOutline, chevronForwardCircleOutline, exit, personCircleOutline, playSkipForwardCircleOutline, print, save, trailSign } from "ionicons/icons";
	import { defineComponent } from "vue";
	import SpotButton from "../components/SpotButton.vue";
	import SpotHeader from "../components/SpotHeader.vue";
	import SpotInput from "../components/SpotInput.vue";
	import SpotSelect from "../components/SpotSelect.vue";
	import SpotSelectCustom from "../components/SpotSelectCustom.vue";
	import TakePhoto from "../components/TakePhoto.vue";
	import { checkUserSession, confirmYesNo, insertValue, showMsgError, showMsgInfo, showMsgWarning } from "../plugins/common.js";
	import { settings } from "../plugins/settings.js";
	import { createAddressee, createCarrier, createEmployee, createItem, createProjectRow, createProjectRowFormData, executePrinterAction, getPrinter, getProject, getProjectRow, tablesData, updateProjectRow, updateProjectRowFormData } from '../plugins/customDatabase.js';
	import { backendUrl } from "../plugins/variables.js";

	export default defineComponent({
		name: "InsertShipment",
		props: {
			pageTitle: { type: String, default: "Spedizione" },
			defaultSpinnerText: { type: String, default: "Caricamento..." },
			loadingEmployeesText: { type: String, default: "Caricamento Dipendenti..." },
			loadingAddresseesText: { type: String, default: "Caricamento Destinatari..." },
			loadingCarriersText: { type: String, default: "Caricamento Corrieri..." },
			loadingItemsText: { type: String, default: "Caricamento Formati..." },
			loadingProjectText: { type: String, default: "Caricamento Testata..." },
			loadingProjectRowText: { type: String, default: "Caricamento Dettaglio..." },
			insertActivity: { type: String, default: "Inserisci " },
			modifyActivity: { type: String, default: "Modifica " },
			viewActivity: { type: String, default: "Visualizza " },
			labelPrint: { type: String, default: "Stampa" },
			labelReprint: { type: String, default: "Ristampa" },
			labelSave: { type: String, default: "Salva" },
			labelAnd: { type: String, default: " e " },
			labelEmployee: { type: String, default: "Nuovo Mittente" }, //"Salva e Inizia da Mittente"
			labelAddressee: { type: String, default: "Nuovo Destinatario" }, //"Salva e Inizia da Destinatario"
			labelExit: { type: String, default: "Termina" },
			exitConfirmTitle: { type: String, default: "Conferma Uscita" },
			exitInsertConfirmMessage: { type: String, default: "Confermi l'uscita dalla maschera di inserimento? <br> Premendo SI il record che si sta inserendo andrà perso!" },
			exitModifyConfirmMessage: { type: String, default: "Confermi l'uscita dalla maschera di modifica? <br> Premendo SI, eventuali modifiche non saranno salvate!" },
			newValueTitle: { type: String, default: "Inserimento Nuovo Valore" },
			messageTitleInsert: { type: String, default: "Inserimento Nuova Spedizione" },
			messageTitleUpdate: { type: String, default: "Modifica Spedizione Esistente" },
			messageTitlePrint: { type: String, default: "Stampa Etichetta" },
			messageTitleCamera: { type: String, default: "Fotocamera" },
			successSaveMessage: { type: String, default: "Record salvato correttamente" },
			successMailMessage: { type: String, default: "E-mail inviata a: " },
			successPrintMessage: { type: String, default: "Stampa etichetta avvenuta correttamente. Etichetta: " },
			errorPrintMessage: { type: String, default: "Errore durante la stampa dell'etichetta" },
			warningPrinterOffline: { type: String, default: "La stampante non è raggiungibile; l'etichetta non è stata stampata" },
			warningCameraNotFound: { type: String, default: "Camera del dispositivo non presente o non utilizzabile!" },
			unselected: { type: String, default: "Nessuno" },
		},
		components: {
			IonPage,
			IonItem,
			IonButton,
			IonIcon,
			IonContent,
			IonSpinner,
			IonLabel,
			IonInput,
			IonCheckbox,
			IonThumbnail,
			SpotHeader,
			SpotButton,
			SpotInput,
			SpotSelect,
			SpotSelectCustom,
			TakePhoto,
		},
		data: () => ({
			isActive: null,
			isClosed: null,
			header_id: null,
			header_code: null,
			multipack: null,
			multiple: null,
			parent_id: null,
			barcode: null,
			sender: null,
			spinnerText: null,
			updatingLibraries: null,
			field: {
				employee: 0,
				addressee: 1,
				carrier: 2,
				item: 3,
				pictures: 4,
				waiting_for_proforma: 5,
				urgent: 6,
				note: 7,
				review: 8,
			},
			fields: {
				currentId: 0,
				list: [ //TODO: Nota che, in realtà canSkip, è poi uguale a NOT required (forse può essere rimosso), forse solo nel riepilogo è diverso, ma ci si può guardare
					{ id: 0, name: 'employee', text: 'Richiedente', allignLabel: false, placeholder: 'Seleziona Dipendente', refTable: 'employees', inputType: "combo", defaultValue: null/*1*/, value: null, required: true, refField: 'id', canAddItem: false, canSkip: true, canGoBack: false, canGoAhead: true, canSave: false, canRefresh: false, canUnlock: false },
					{ id: 1, name: 'addressee', text: 'Destinatario', allignLabel: false, placeholder: 'Seleziona Destinatario', refTable: 'addressees', inputType: "combo", defaultValue: null, value: null, required: true, refField: 'name', canAddItem: true, canSkip: true, canGoBack: true, canGoAhead: true, canSave: false, canRefresh: false, canUnlock: false },
					{ id: 2, name: 'carrier', text: 'Corriere', allignLabel: false, placeholder: 'Seleziona Corriere', refTable: 'carriers', inputType: "combo", defaultValue: null, value: null, required: true, refField: 'name', canAddItem: true, canSkip: true, canGoBack: true, canGoAhead: true, canSave: false, canRefresh: false, canUnlock: false },
					{ id: 3, name: 'item', text: 'Formato', allignLabel: false, placeholder: 'Seleziona Formato Spedizione', refTable: 'items', inputType: "combo", defaultValue: null, value: null, required: true, refField: 'code', canAddItem: true, canSkip: true, canGoBack: true, canGoAhead: true, canSave: false, canRefresh: false, canUnlock: false },
					{ id: 4, name: 'pictures', text: 'Immagine', allignLabel: false, placeholder: 'Aggiungi Foto', refTable: null, inputType: "button", defaultValue: null, value: null, required: false, refField: null, canAddItem: false/*true*/, canSkip: true, canGoBack: true, canGoAhead: true, canSave: false, canRefresh: false, canUnlock: false },
					{ id: 5, name: 'waiting_for_proforma', text: 'Attendi Pro forma', allignLabel: false, placeholder: '', refTable: null, inputType: "check", defaultValue: null/*false*/, value: null/*false*/, required: false, refField: null, canAddItem: false, canSkip: true, canGoBack: true, canGoAhead: true, canSave: false, canRefresh: false, canUnlock: false },
					{ id: 6, name: 'urgent', text: 'Urgente', allignLabel: false, placeholder: '', refTable: null, inputType: "check", defaultValue: null/*false*/, value: null/*false*/, required: false, refField: null, canAddItem: false, canSkip: true, canGoBack: true, canGoAhead: true, canSave: false, canRefresh: false, canUnlock: false },
					{ id: 7, name: 'note', text: 'Note', allignLabel: false, placeholder: 'Inserisci Note', refTable: null, inputType: "text", defaultValue: null, value: null, required: false, refField: null, canAddItem: false, canSkip: true, canGoBack: true, canGoAhead: true, canSave: false, canRefresh: false, canUnlock: false },
					{ id: 8, name: 'review', text: 'RIEPILOGO', allignLabel: false, placeholder: '', refTable: null, inputType: "readOnlyTexts", defaultValue: null, value: null, required: false, refField: null, canAddItem: false, canSkip: false, canGoBack: true, canGoAhead: false, canSave: true, canRefresh: false, canUnlock: false },
				],
			},
			showActionButtonsText : true,
			hasChangedPhoto : false,
			chevronBackCircleOutline,
			chevronForwardCircleOutline,
			addCircleOutline,
			trailSign,
			personCircleOutline,
			exit,
			save,
			print,
			playSkipForwardCircleOutline,
			settings,
			confirmYesNo,
			checkUserSession,
			insertValue,
			showMsgInfo,
			showMsgWarning,
			showMsgError,
			createAddressee,
			createCarrier,
			createEmployee,
			createItem,
			createProjectRow,
			createProjectRowFormData,
			executePrinterAction,
			getPrinter,
			getProject,
			getProjectRow,
			tablesData,
			updateProjectRow,
			updateProjectRowFormData,
			backendUrl,
		}),
		computed: {
			currField() {
				return this.fields.list[this.fields.currentId]
			},
			canPrint() {
				return (this.settings.global.printerManagement && this.tablesData.currentPrinter != null)
			},
			recActivity() {
				if (this.$route.params.id && this.isClosed) return this.viewActivity
				else if (this.$route.params.id && !this.isClosed) return this.modifyActivity
				else if (!this.$route.params.id) return this.insertActivity
				else return ""
			},
			getImageUrl() {
				if (typeof this.fields.list[this.field.pictures].value == 'string')
					return this.fields.list[this.field.pictures].value
				else
					return URL.createObjectURL(this.fields.list[this.field.pictures].value)
			}
		},
		async ionViewWillEnter() {
			this.setDefault();
			await this.getAllTablesData();
			await this.getCurrentProjectRow();
			await this.getCurrentProject();
			if (this.settings.insertShipment.skipToReview == true && this.isEmptyRequiredFields() == false) {
				setTimeout(() => this.goToReview(), 0);
			}
			this.isActive=true;
		},
		ionViewWillLeave() {
			document.activeElement?.blur();
			this.isActive=false;
		},
		methods: {
			//Settings
			tryExit() {
				if (!this.isClosed && !this.fields.list[this.fields.list.length-1].value) {
					this.confirmYesNo(this.exitConfirmTitle, (this.$route.params.id ? this.exitModifyConfirmMessage : this.exitInsertConfirmMessage))
					.then((data) => {
						if (data == true) {
							if (!this.multipack) this.$router.push("/home");
							else this.$router.push(`/revision/multiple/` + this.header_id + `?code=` + this.header_code);
						}
					})
				}
				else {
					if (!this.multipack) this.$router.push("/home");
					else this.$router.push(`/revision/multiple/` + this.header_id + `?code=` + this.header_code);
				}
			},
			getPlaceHolder() {
				return ((this.settings.global.showFieldsPlaceholder) ? (this.currField.required ? this.currField.placeholder : this.unselected ) : '')
			},
			isDisableButton(ability) {
				if (this.settings.global.fieldsCheckOnButtons /*&& ability*/) {
					return (this.currField.required && !this.currField.value) ? true : false
				}
				else {
					return !ability
				}
			},
			isEmptyRequiredFields() {
				let ret = false;
				this.fields.list.forEach(element => {if (element.required && !element.value) ret=true});
				return ret;
			},
			isVisibleButton(ability) {
				return (this.settings.global.hideUnneededButtons) ? ability : true
			},
			customEmployee ({ name, surname, department, seat, seat_code }) {
				let infoDepartment = "";
				if (department)
					infoDepartment = " (" + department.name + ")"
				else if (seat)
					infoDepartment = " (" + seat + ")"
				else if (seat_code)
					infoDepartment = " (" + seat_code + ")"
				return name + " " + surname + infoDepartment
			},
			getEmployeeDepartment(srcObject) {
				let infoDepartment = "";
				if (srcObject.department)
					infoDepartment = " (" + srcObject.department.name + ")"
				else if (srcObject.seat)
					infoDepartment = " (" + srcObject.seat + ")"
				else if (srcObject.seat_code)
					infoDepartment = " (" + srcObject.seat_code + ")"
				return srcObject.name + " " + srcObject.surname + infoDepartment
			},
			//Database
			async getAllTablesData() {
				// Do Nothing
			},
			prepareNewProjectRow() {
				let myRecord = {
					project_row: {
						project_id: this.header_id,
						employee_id: (this.fields.list[this.field.employee].value) ? this.fields.list[this.field.employee].value.id : null,
						addressee_id: (this.fields.list[this.field.addressee].value) ? this.fields.list[this.field.addressee].value.id : null,
						carrier_id: (this.fields.list[this.field.carrier].value) ? this.fields.list[this.field.carrier].value.id : null,
						item_id: (this.fields.list[this.field.item].value) ? this.fields.list[this.field.item].value.id : null,
						waiting_for_proforma: (this.fields.list[this.field.waiting_for_proforma].value) ? this.fields.list[this.field.waiting_for_proforma].value : false,
						urgent: (this.fields.list[this.field.urgent].value) ? this.fields.list[this.field.urgent].value : false,
						notes: (this.fields.list[this.field.note].value) ? this.fields.list[this.field.note].value : null,
						project_row_id: this.parent_id,
						warehouse_id: this.tablesData.currentWarehouse.id,
						plant_id: this.tablesData.currentPlant.id,
					}
				};
				return myRecord;
			},
			prepareNewProjectRow_FormData() {
				let myRecord = new FormData();
				myRecord.append('project_rows[project_id]', this.header_id);
				if (this.fields.list[this.field.employee].value) myRecord.append('project_rows[employee_id]', this.fields.list[this.field.employee].value.id);
				if (this.fields.list[this.field.addressee].value) myRecord.append('project_rows[addressee_id]', this.fields.list[this.field.addressee].value.id);
				if (this.fields.list[this.field.carrier].value) myRecord.append('project_rows[carrier_id]', this.fields.list[this.field.carrier].value.id);
				if (this.fields.list[this.field.item].value) myRecord.append('project_rows[item_id]', this.fields.list[this.field.item].value.id);
				myRecord.append('project_rows[pictures][]', this.fields.list[this.field.pictures].value);
				myRecord.append('project_rows[waiting_for_proforma]', (this.fields.list[this.field.waiting_for_proforma].value) ? this.fields.list[this.field.waiting_for_proforma].value : false);
				myRecord.append('project_rows[urgent]', (this.fields.list[this.field.urgent].value) ? this.fields.list[this.field.urgent].value : false);
				if (this.fields.list[this.field.note].value) myRecord.append('project_rows[notes]', this.fields.list[this.field.note].value);
				if (this.project_row_id) myRecord.append('project_rows[project_row_id]', this.parent_id);
				myRecord.append('project_rows[warehouse_id]', this.tablesData.currentWarehouse.id);
				myRecord.append('project_rows[plant_id]', this.tablesData.currentPlant.id);
				return myRecord;
			},
			prepareUpdateProjectRow() {
				let myRecord = {
					project_row: {
						employee_id: (this.fields.list[this.field.employee].value) ? this.fields.list[this.field.employee].value.id : null,
						addressee_id: (this.fields.list[this.field.addressee].value) ? this.fields.list[this.field.addressee].value.id : null,
						carrier_id: (this.fields.list[this.field.carrier].value) ? this.fields.list[this.field.carrier].value.id : null,
						item_id: (this.fields.list[this.field.item].value) ? this.fields.list[this.field.item].value.id : null,
						pictures: (this.fields.list[this.field.pictures].value) ? this.fields.list[this.field.pictures].value.id : null,
						waiting_for_proforma: (this.fields.list[this.field.waiting_for_proforma].value) ? this.fields.list[this.field.waiting_for_proforma].value : false,
						urgent: (this.fields.list[this.field.urgent].value) ? this.fields.list[this.field.urgent].value : false,
						notes: (this.fields.list[this.field.note].value) ? this.fields.list[this.field.note].value : null,
						// project_row_id: this.parent_id,
						warehouse_id: this.tablesData.currentWarehouse.id,
						plant_id: this.tablesData.currentPlant.id,
					}
				};
				return myRecord;
			},
			prepareUpdateProjectRow_FormData() {
				let myRecord = new FormData();
				if (this.fields.list[this.field.employee].value) myRecord.append('project_rows[employee_id]', this.fields.list[this.field.employee].value.id);
				if (this.fields.list[this.field.addressee].value) myRecord.append('project_rows[addressee_id]', this.fields.list[this.field.addressee].value.id);
				if (this.fields.list[this.field.carrier].value) myRecord.append('project_rows[carrier_id]', this.fields.list[this.field.carrier].value.id);
				if (this.fields.list[this.field.item].value) myRecord.append('project_rows[item_id]', this.fields.list[this.field.item].value.id);
				if (this.hasChangedPhoto) myRecord.append('project_rows[pictures][]', this.fields.list[this.field.pictures].value);
				myRecord.append('project_rows[waiting_for_proforma]', (this.fields.list[this.field.waiting_for_proforma].value) ? this.fields.list[this.field.waiting_for_proforma].value : false);
				myRecord.append('project_rows[urgent]', (this.fields.list[this.field.urgent].value) ? this.fields.list[this.field.urgent].value : false);
				if (this.fields.list[this.field.note].value) myRecord.append('project_rows[notes]', this.fields.list[this.field.note].value); else myRecord.append('project_rows[notes]', '');
				// if (this.project_row_id) myRecord.append('project_rows[project_row_id]', this.parent_id);
				myRecord.append('project_rows[warehouse_id]', this.tablesData.currentWarehouse.id);
				myRecord.append('project_rows[plant_id]', this.tablesData.currentPlant.id);
				return myRecord;
			},
			async saveRecord() {
				if (!this.fields.list[this.field.pictures].value) await this.saveRecordJson();
				else await this.saveRecordFormData();
			},
			async saveRecordJson() {
				this.tablesData.currentProjectRow = null;
				await this.createProjectRow(this.prepareNewProjectRow(), false);
				if (this.tablesData.currentProjectRow) {
					this.barcode = this.tablesData.currentProjectRow.code;
					let currEmployee = "";
					if (this.tablesData.currentProjectRow.employee) {
						this.sender = "<br><br>" + this.successMailMessage + "&nbsp" + this.tablesData.currentProjectRow.employee.name + "&nbsp" + this.tablesData.currentProjectRow.employee.surname;
						currEmployee = this.tablesData.currentProjectRow.employee.name + ` ` + this.tablesData.currentProjectRow.employee.surname;
					} else {
						this.sender = ""/*null*/;
					}
					this.currField.value = true;
					if (this.canPrint) {
						await this.getPrinter(this.tablesData.currentPrinter.id);
						if (this.tablesData.currentPrinter.is_online == true) {
							await this.executePrinterAction(`printers/` + this.tablesData.currentPrinter.id + `?do=print_single_barcode` + `&barcode=` + this.barcode + `&direction=MITTENTE:` + `&employee=` + currEmployee + `&datetime=` + new Date().toLocaleString("it-IT"))
							.then(() => {
								this.showMsgInfo(this.messageTitleInsert, this.successSaveMessage + this.sender + "<br><br>" + this.successPrintMessage + "&nbsp" + this.barcode);
							})
							.catch(error => {
								this.checkUserSession(error, "warning");
								this.showMsgError(this.messageTitlePrint, this.errorPrintMessage);
							})
						}
						else { 
							this.showMsgWarning(this.messageTitleInsert, this.successSaveMessage + this.sender + "<br><br>" + this.warningPrinterOffline);
						}
					}
					else {
						this.showMsgInfo(this.messageTitleInsert, this.successSaveMessage + this.sender);
					}
				}
			},
			async saveRecordFormData() {
				this.tablesData.currentProjectRow = null;
				await this.createProjectRowFormData(this.prepareNewProjectRow_FormData(), false);
				if (this.tablesData.currentProjectRow) {
					this.barcode = this.tablesData.currentProjectRow.code;
					let currEmployee = "";
					if (this.tablesData.currentProjectRow.employee) {
						this.sender = "<br><br>" + this.successMailMessage + "&nbsp" + this.tablesData.currentProjectRow.employee.name + "&nbsp" + this.tablesData.currentProjectRow.employee.surname;
						currEmployee = this.tablesData.currentProjectRow.employee.name + ` ` + this.tablesData.currentProjectRow.employee.surname;
					} else {
						this.sender = ""/*null*/;
					}
					this.currField.value = true;
					if (this.canPrint) {
						await this.getPrinter(this.tablesData.currentPrinter.id);
						if(this.tablesData.currentPrinter.is_online == true) {
							await this.executePrinterAction(`printers/` + this.tablesData.currentPrinter.id + `?do=print_single_barcode` + `&barcode=` + this.barcode + `&direction=MITTENTE:` + `&employee=` + currEmployee + `&datetime=` + new Date().toLocaleString("it-IT"))
							.then(() => {
								this.showMsgInfo(this.messageTitleInsert, this.successSaveMessage + this.sender + "<br><br>" + this.successPrintMessage + "&nbsp" + this.barcode);
							})
							.catch(error => {
								this.checkUserSession(error, "warning");
								this.showMsgError(this.messageTitlePrint, this.errorPrintMessage);
							})
						}
						else {
							this.showMsgWarning(this.messageTitleInsert, this.successSaveMessage + this.sender + "<br><br>" + this.warningPrinterOffline);
						}
					}
					else {
						this.showMsgInfo(this.messageTitleInsert, this.successSaveMessage + this.sender);
					}
				}
			},
			async updateRecord() {
				if (!this.fields.list[this.field.pictures].value) await this.updateRecordJson();
				else await this.updateRecordFormData();
			},
			async updateRecordJson() {
				this.tablesData.currentProjectRow = null;
				await this.updateProjectRow(this.$route.params.id, this.prepareUpdateProjectRow(), false)
				if (this.tablesData.currentProjectRow) {
					this.showMsgInfo(this.messageTitleUpdate, this.successSaveMessage /*+ "<br><br>" + this.successMailMessage + "&nbsp" + data.employee.name + "&nbsp" + data.employee.surname*/);
					if (!this.multipack) this.$router.push("/home");
					else this.$router.push(`/revision/multiple/` + this.header_id + `?code=` + this.header_code);
				}
			},
			async updateRecordFormData() {
				this.tablesData.currentProjectRow = null;
				await this.updateProjectRowFormData(this.$route.params.id, this.prepareUpdateProjectRow_FormData(), false)
				if (this.tablesData.currentProjectRow) {
					this.showMsgInfo(this.messageTitleUpdate, this.successSaveMessage /*+ "<br><br>" + this.successMailMessage + "&nbsp" + data.employee.name + "&nbsp" + data.employee.surname*/);
					if (!this.multipack) this.$router.push("/home");
					else this.$router.push(`/revision/multiple/` + this.header_id + `?code=` + this.header_code);
				}
			},
			async getCurrentProjectRow() {
				if (this.$route.params.id) {
					this.updatingLibraries = true;
					this.spinnerText = this.loadingProjectRowText;
					await this.getProjectRow(this.$route.params.id);
					this.updatingLibraries = false;
					if (this.tablesData.currentProjectRow) {
						this.currentRec = this.tablesData.currentProjectRow;
						this.fields.list[this.field.employee].value=(this.currentRec.employee) ? this.currentRec.employee : null;
						this.fields.list[this.field.addressee].value=(this.currentRec.addressee) ? this.currentRec.addressee : null;
						this.fields.list[this.field.carrier].value=(this.currentRec.carrier) ? this.currentRec.carrier : null;
						this.fields.list[this.field.item].value=(this.currentRec.item) ? this.currentRec.item : null;
						this.fields.list[this.field.pictures].value=(this.currentRec.picture_urls) ? this.backendUrl + this.currentRec.picture_urls : null;
						this.fields.list[this.field.waiting_for_proforma].value=(this.currentRec.waiting_for_proforma) ? this.currentRec.waiting_for_proforma : false;
						this.fields.list[this.field.urgent].value=(this.currentRec.urgent) ? this.currentRec.urgent : false;
						this.fields.list[this.field.note].value=(this.currentRec.notes && this.currentRec.notes.body) ? this.currentRec.notes.body : null;
						this.isClosed=(this.currentRec.closed) ? true : false;
						this.project_row_id=this.currentRec.parent_id;
						this.header_id=this.currentRec.project.id;
						this.header_code=this.currentRec.project.code;
					}
				}
				if (this.$route.query.header_id) this.header_id = parseInt(this.$route.query.header_id);
				if (this.$route.query.multiple) this.multiple = (this.$route.query.multiple === 'true');
				if (this.$route.query.multipack) this.multipack = (this.$route.query.multipack === 'true');
				if (this.$route.query.parent_id) this.parent_id = parseInt(this.$route.query.parent_id);
			},
			async getCurrentProject() {
				if (this.$route.query.header_id) {
					this.updatingLibraries = true;
					this.spinnerText = this.loadingProjectText;
					await this.getProject(this.header_id);
					this.updatingLibraries = false;
					if (this.tablesData.currentProject) {
						this.header_code = this.tablesData.currentProject.code;
						if (this.multipack || this.parent_id) {
							this.fields.list[this.field.employee].value=(this.tablesData.currentProject.employee) ? this.tablesData.currentProject.employee : null;
							this.fields.list[this.field.addressee].value=(this.tablesData.currentProject.addressee) ? this.tablesData.currentProject.addressee : null;
							this.fields.list[this.field.carrier].value=(this.tablesData.currentProject.carrier) ? this.tablesData.currentProject.carrier : null;
							this.fields.list[this.field.item].value=(this.tablesData.currentProject.item) ? this.tablesData.currentProject.item : null;
						}
					}
				}
			},
			//Actions
			async createAndPrint() {
				if (!this.$route.params.id) {
					if (!this.currField.value) {
						await this.saveRecord();
					}
					else {
						let currEmployee = (this.fields.list[this.field.employee].value) ? this.fields.list[this.field.employee].value.name + ` ` + this.fields.list[this.field.employee].value.surname : ""/*null*/;
						if (this.canPrint) {
							await this.getPrinter(this.tablesData.currentPrinter.id);
							if(this.tablesData.currentPrinter.is_online == true) {
								await this.executePrinterAction(`printers/` + this.tablesData.currentPrinter.id + `?do=print_single_barcode` + `&barcode=` + this.barcode + `&direction=MITTENTE:` + `&employee=` + currEmployee + `&datetime=` + new Date().toLocaleString("it-IT"))
								.then(() => {
									this.showMsgInfo(this.messageTitlePrint,this.successPrintMessage + "&nbsp" + this.barcode);
								})
								.catch(error => {
									this.checkUserSession(error, "warning");
									this.showMsgError(this.messageTitlePrint, this.errorPrintMessage);
								})
							}
							else {
								this.showMsgWarning(this.messageTitlePrint,this.warningPrinterOffline);
							}
						}
					}
				}
				else {
					this.updateRecord();
				}
			},
			executeAction(action) {
				if (!this.$route.params.id) {
					switch (action) {
						case 'NewEmployee':
							this.fields.currentId = this.field.employee;
							this.fields.list.forEach(element => {if (element.id > 0) element.value = element.defaultValue;});
							break;
						case 'NewAddressee':
							this.fields.currentId = this.field.addressee;
							this.fields.list.forEach(element => {if (element.id > 1) element.value = element.defaultValue;});
							break;
						case 'Exit':
							if (!this.multipack) this.$router.push("/home");
							else this.$router.push(`/revision/multiple/` + this.header_id + `?code=` + this.header_code);
							break;
						default:
							//TODO: aggiungi checkUserSession (ma non dovrebbe mai arrivarci)
					}
				}
			},
			async setDefault() {
				this.spinnerText = this.defaultSpinnerText;
				this.fields.currentId = 0;
				this.fields.list.forEach(element => element.value = element.defaultValue);
				this.isClosed = false;
				this.multiple = false;
				this.multipack = false;
				this.parent_id = null;
				this.header_id = null;
				this.header_code = null;
				this.hasChangedPhoto = false;
				this.updatingLibraries = false;
			},
			goToNextOrLastField() {
				if (this.settings.insertShipment.skipToReview == true && this.isEmptyRequiredFields() == false) {
					setTimeout(() => this.goToReview(), 0);
				} else {
					setTimeout(() => this.goAhead(), 0);
				}
			},
			//Events
			detectReturn(keyCode) {
				if (keyCode == 13) this.goToNextOrLastField();
			},
			changedInput(value) {
				this.currField.value = value;
			},
			committedInput() {
				this.goToNextOrLastField();
			},
			detectSelection(value) {
				this.currField.value = value;
				if (this.settings.global.nextFieldOnComboSelect) this.goToNextOrLastField();
			},
			detectUnselection() {
				this.currField.value = this.currField.defaultValue;
			},
			goBack() {
				if (this.fields.currentId >= 0 ) this.fields.currentId-=1;
			},
			goAhead() {
				if (this.fields.currentId <= (this.fields.list.length-1) ) this.fields.currentId+=1
				else this.executeLastFieldAction()
			},
			goToReview() {
				if (this.fields.currentId >= 0 && this.fields.currentId <= (this.fields.list.length-1) ) this.fields.currentId=this.fields.list.length-1
			},
			goToField(targetFieldId) {
				if (targetFieldId >= 0 && targetFieldId <= (this.fields.list.length-1) ) this.fields.currentId=targetFieldId
			},
			assignImage(file) {
				this.hasChangedPhoto = true;
				this.currField.value = file;
				this.goToNextOrLastField();
			},
			clearImage() {
				this.currField.value = null;
			},
			cameraNotFound() {
				this.showMsgWarning(
					this.messageTitleCamera,
					this.warningCameraNotFound);
			},
			executeLastFieldAction() {
				//TODO: Da Implementare (vedi quello della Insert, ma forse non serve perchè potrei abilitare solo il pulsante di salvataggio)
			},
			async addEmployee() {
				let fieldValue = null;
				await this.insertValue(this.newValueTitle, this.currField.text)
				.then((data) => { if (data) { fieldValue = data } })
				if (fieldValue) {
					let myRecord = {
						employees: {
							name: fieldValue,
						}
					}
					this.updatingLibraries = true;
					this.spinnerText = this.loadingEmployeesText;
					await this.createEmployee(myRecord);
					this.updatingLibraries = false;
					this.currField.value = this.tablesData.currentEmployee;
				}
			},
			async addAddressee() {
				let fieldValue = null;
				await this.insertValue(this.newValueTitle, this.currField.text)
				.then((data) => { if (data) { fieldValue = data } })
				if (fieldValue) {
					let myRecord = {
						addressees: {
							name: fieldValue,
						}
					}
					this.updatingLibraries = true;
					this.spinnerText = this.loadingAddresseesText;
					await this.createAddressee(myRecord);
					this.updatingLibraries = false;
					this.currField.value = this.tablesData.currentAddressee;
				}
			},
			async addCarrier() {
				let fieldValue = null;
				await this.insertValue(this.newValueTitle, this.currField.text)
				.then((data) => { if (data) { fieldValue = data } })
				if (fieldValue) {
					let myRecord = {
						carriers: {
							name: fieldValue,
						}
					}
					this.updatingLibraries = true;
					this.spinnerText = this.loadingCarriersText;
					await this.createCarrier(myRecord);
					this.updatingLibraries = false;
					this.currField.value = this.tablesData.currentCarrier;
				}
			},
			async addItem() {
				let fieldValue = null;
				await this.insertValue(this.newValueTitle, this.currField.text)
				.then((data) => { if (data) { fieldValue = data } })
				if (fieldValue) {
					let myRecord = {
						items: {
							code: fieldValue,
							location_id: 1,
						}
					}
					this.updatingLibraries = true;
					this.spinnerText = this.loadingItemsText;
					await this.createItem(myRecord);
					this.updatingLibraries = false;
					this.currField.value = this.tablesData.currentItem;
				}
			},
		},
	});
</script>